export const getDataACL = () => {
  const storedData = localStorage.getItem("data-acl");

  if (storedData) {
    try {
      const data = JSON.parse(storedData);
      return data.data || "";
    } catch (error) {
      console.error("Error parsing JSON from localStorage:", error);
      return "";
    }
  }

  return null;
};
